import { Grid, IconButton } from '@mui/material';
import React, { useRef, useState } from 'react';
// import ReactToPrint from 'react-to-print';
import PieChartRelatorio from '../PieChartRelatorio';
import { usePallet } from "../../../../contexts/PalletContext";
import styled from 'styled-components';
import legis_agenda from "../../../../img/logo_legis_alta.png";
import PrintIcon from '@mui/icons-material/Print';
import { isMobile, isWindows } from 'react-device-detect';
import legis_agenda2 from "../../../../img/legis_agenda2.png";
import { fontSize } from '@mui/system';
import RelatorioService from "../../../../services/RelatoriosService";
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { useQuery } from '../../../../utils/utils';
import CircularLoading from '../../../../components/CircularLoading';


export default function RelatorioProposicoesPorNivelPrioridade() {
    const { pallet } = usePallet();
    const { dtIni } = useParams() as any;
    const { dtFin } = useParams() as any;
    const [loading, setLoading] = useState(false)

    let filter = useQuery().get('filter');
    
    const [filtro, setFiltro] = useState(filter)
    const [countMinima, setCountMinima] = useState()
    const [countBaixa, setCountBaixa] = useState()
    const [countMedia, setCountMedia] = useState()
    const [countAlta, setCountAlta] = useState()
    const [countMaxima, setCountMaxima] = useState()
    const [dataMinima, setDataMinima] = useState([])
    const [dataBaixa, setDataBaixa] = useState([])
    const [dataMedia, setDataMedia] = useState([])
    const [dataAlta, setDataAlta] = useState([])
    const [dataMaxima, setDataMaxima] = useState([])

    //let esferaTipo = filter.substring(27, 29)
    let filtrotitle = []

    try { filtrotitle = JSON.parse(filter) } catch { filtrotitle = [] };
    
    let esferaTipo = (filtrotitle.length>0 ? filtrotitle[0].value : "Geral")


    const Imprimir = () => {
        window.print()
    }

    React.useEffect(() => {
        setLoading(true)

        if (
            String(format(new Date(dtIni), "yyyy")).slice(0, 1) !== "0" &&
            String(format(new Date(dtFin), "yyyy")).slice(0, 1) !== "0"
        ) {


            RelatorioService.GetProposicoesPorNivelPrioridade(
                format(new Date(dtIni), "yyyy-MM-dd"),
                format(new Date(dtFin), "yyyy-MM-dd 23:59:00.000"),
                String(filtro)
            ).then(async res => {
                setCountMinima(res?.data?.prioridades?.minima)
                setCountBaixa(res?.data?.prioridades?.baixa)
                setCountMedia(res?.data?.prioridades?.media)
                setCountAlta(res?.data?.prioridades?.alta)
                setCountMaxima(res?.data?.prioridades?.maxima)
                setDataMinima(res?.data?.prioTipos?.propTiposPrioMinima)
                setDataBaixa(res?.data?.prioTipos?.propTiposPrioBaixa)
                setDataMedia(res?.data?.prioTipos?.propTiposPrioMedia)
                setDataAlta(res?.data?.prioTipos?.propTiposPrioAlta)
                setDataMaxima(res?.data?.prioTipos?.propTiposPrioMaxima)
                setLoading(false)
            })
        }
    }, []);

    const CheckEsfera = (select) => {
        switch (select) {
            case 'F':
                return 'Federal'
            case 'E':
                return 'Estadual'
            case 'M':
                return 'Municipal'
            default:
                return 'Federal'
        }
    }

    return (
        <div>
            <div className="relativeCSS">
                <style type="text/css" media="print">
                    {"\
                        @page { size: A4; }\
                    "}
                </style>
                <div className="flash" />
                <div style={{ width: '1000px', WebkitPrintColorAdjust: 'exact' }} >
                    <table className="testClass" style={{ width: '1000px' }} >
                        <thead>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        padding: "20px",
                                        backgroundColor: `${pallet.general.color1}`,
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        height: '70px'
                                    }}>
                                        <Grid style={{}}>
                                            <img style={{ width: '100px' }} src={legis_agenda} />
                                        </Grid>
                                        <Grid style={{
                                            color: 'white',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size12}`
                                        }}>
                                            Monitoramento Inteligente no Poder Legislativo
                                        </Grid>
                                        <Grid>
                                            <IconButton onClick={Imprimir} style={{ color: 'white' }} aria-label="upload picture" component="span">
                                                <PrintIcon />
                                            </IconButton>
                                        </Grid>

                                    </Grid>
                                </td>
                            </tr>
                        </thead>
                        <tbody style={{
                            width: '900px',
                            // display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        width: '990px',
                                        padding: '30px'
                                    }}>
                                        <Grid style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "left",
                                            // alignItems: "left",
                                        }}>
                                            <img style={{ width: '100px' }} src={legis_agenda2} />
                                        </Grid>
                                        <Grid style={{ marginLeft: '50px' }}>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: `${pallet.general.size16}`,
                                            }}>
                                                Relatório / {esferaTipo}
                                            </Grid>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: '20px',
                                                fontWeight: pallet.general.weight_bold,
                                                marginTop: '8px'
                                            }}>
                                                Proposições Classificadas por Nível de Prioridade
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </td>
                            </tr>
                            <tr >
                                <td>
                                    {loading ?
                                        <CircularLoading
                                            size={100}
                                            top={isMobile ? "37%" : "40%"}
                                            left={isMobile ? "6%" : "16%"}
                                            zIndex={2}
                                        />
                                        :
                                        <Grid style={{
                                            width: '990px',
                                            paddingLeft: '5px',
                                            marginTop: '30px'
                                        }}>
                                            <PieChartRelatorio
                                                title="PERÍODO DE APRESENTAÇÃO"
                                                dtIni={dtIni}
                                                dtFin={dtFin}
                                                labels={[
                                                    {
                                                        key: "Mínima",
                                                        data: Number(countMinima),
                                                        color: `${pallet.color.charts.red}`,
                                                        url: '/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"prioridade","label":"Prioridade: Mínima","value":1},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]'
                                                    },
                                                    {
                                                        key: "Baixa",
                                                        data: Number(countBaixa),
                                                        color: `${pallet.color.charts.green}`,
                                                        url: '/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"prioridade","label":"Prioridade: Baixa","value":2},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]'
                                                    },
                                                    {
                                                        key: "Média",
                                                        data: Number(countMedia),
                                                        color: `${pallet.color.charts.purple}`,
                                                        url: '/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"prioridade","label":"Prioridade: Média","value":3},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]'
                                                    },
                                                    {
                                                        key: "Alta",
                                                        data: Number(countAlta),
                                                        color: `${pallet.color.charts.yellow}`,
                                                        url: '/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"prioridade","label":"Prioridade: Alta","value":4},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]'
                                                    },
                                                    {
                                                        key: "Máxima",
                                                        data: Number(countMaxima),
                                                        color: `${pallet.color.charts.blue}`,
                                                        url: '/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"prioridade","label":"Prioridade: Máxima","value":5},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]'
                                                    },
                                                ]}
                                            />
                                        </Grid>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{
                                    marginTop: '70px',
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_600,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | MÍNIMA
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TIPO DE PROPOSIÇÃO
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataMinima?.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tipo}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                    cursor:"pointer"
                                                }}
                                                onClick={() => window.open('/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"prioridade","label":"Prioridade: Mínima","value":1},{"key":"tipo","label":"TIPO : '+ x.tipo +'","value":"'+ x.tipo +'" },{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                        format(new Date(dtIni), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtIni), "MM/dd/yyyy") +
                                                        '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                        format(new Date(dtFin), "yyyy-MM-dd") +
                                                        '","value" : "' +
                                                        format(new Date(dtFin), "MM/dd/yyyy") +
                                                        '"}]','_blank')}>
                                                    {x.qtd}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{
                                    marginTop: '70px',
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_600,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | BAIXA
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TIPO DE PROPOSIÇÃO
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataBaixa?.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tipo}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => window.open('/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"prioridade","label":"Prioridade: Baixa","value":2},{"key":"tipo","label":"TIPO : '+ x.tipo +'","value":"'+ x.tipo +'" },{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                format(new Date(dtIni), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtIni), "MM/dd/yyyy") +
                                                '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                format(new Date(dtFin), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtFin), "MM/dd/yyyy") +
                                                '"}]','_blank')}>
                                                    {x.qtd}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{
                                    marginTop: '70px',
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_600,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | MÉDIA
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TIPO DE PROPOSIÇÃO
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataMedia?.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}
>
                                                    {x.tipo}
                                                </Grid>
                                                <Grid  onClick={() => window.open('/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"prioridade","label":"Prioridade: Media","value":3},{"key":"tipo","label":"TIPO : '+ x.tipo +'","value":"'+ x.tipo +'" },{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                format(new Date(dtIni), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtIni), "MM/dd/yyyy") +
                                                '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                format(new Date(dtFin), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtFin), "MM/dd/yyyy") +
                                                '"}]','_blank')} style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                    cursor: 'pointer'
                                                }}>
                                                    {x.qtd}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{
                                    marginTop: '70px',
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_600,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | ALTA
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TIPO DE PROPOSIÇÃO
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataAlta?.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tipo}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => window.open('/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"prioridade","label":"Prioridade: Alta","value":4},{"key":"tipo","label":"TIPO : '+ x.tipo +'","value":"'+ x.tipo +'" },{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                format(new Date(dtIni), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtIni), "MM/dd/yyyy") +
                                                '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                format(new Date(dtFin), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtFin), "MM/dd/yyyy") +
                                                '"}]','_blank')}>
                                                    {x.qtd}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                    <table>
                        <tbody>
                            <tr>
                                <Grid style={{
                                    marginTop: '70px',
                                    fontSize: `${pallet.general.size18}`,
                                    fontFamily: `${pallet.general.fontFamily}`,
                                    fontWeight: pallet.general.weight_600,
                                    color: `${pallet.color.secundary.font}`
                                }}>
                                    | MÁXIMA
                                </Grid>
                            </tr>
                        </tbody>
                    </table>
                    <Grid style={{
                        border: `1px solid #e0e0e0`,
                        marginTop: '20px',
                        borderRadius: '7px'
                    }}>
                        <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                            <tbody>
                                <tr>
                                    <Grid container
                                        display='flex'
                                        justifyContent={'flex-start'}
                                        direction='row'
                                        style={{
                                            height: '50px',
                                            backgroundColor: `${pallet.backgroundGeneralPage}`,
                                            borderTopLeftRadius: '7px',
                                            borderTopRightRadius: '7px'
                                        }}
                                    >
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            TIPO DE PROPOSIÇÃO
                                        </Grid>
                                        <Grid style={{
                                            width: '495px',
                                            paddingTop: '15px',
                                            paddingLeft: '25px',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size14}`,
                                            color: `${pallet.textColorSecondary}`,
                                            fontWeight: pallet.general.weight_600
                                        }}>
                                            QUANTIDADE
                                        </Grid>
                                    </Grid>
                                </tr>
                            </tbody>
                        </table>
                        {dataMaxima?.map(x => {
                            return (
                                <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                    <tbody>
                                        <tr>
                                            <Grid container
                                                display='flex'
                                                justifyContent={'flex-start'}
                                                direction='row'
                                                style={{
                                                    height: '50px',
                                                    borderTop: `1px solid #e0e0e0`
                                                }}
                                            >
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                }}>
                                                    {x.tipo}
                                                </Grid>
                                                <Grid style={{
                                                    width: '495px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '25px',
                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                    fontSize: `${pallet.general.size14}`,
                                                    cursor: 'pointer'
                                                    
                                                }}
                                                onClick={() => window.open('/proposicao?filtro=[{"key":"esfera","label":"ESFERA: Federal","value":"Federal"},{"key":"prioridade","label":"Prioridade: Máxima","value":5},{"key":"tipo","label":"TIPO : '+ x.tipo +'","value":"'+ x.tipo +'" },{"key":"emTramitacao","label":"EM TRAMITAÇÃO: Sim","value":true},{"key":"visualizacao","label":"VISUALIZAÇÃO: Seguidas","value":"Seguidas"},{"key":"dataIni","label":"DATA APRESENTAÇÃO INICIAL: ' +
                                                format(new Date(dtIni), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtIni), "MM/dd/yyyy") +
                                                '"},{"key":"dataFin","label":"DATA APRESENTAÇÃO FINAL: ' +
                                                format(new Date(dtFin), "yyyy-MM-dd") +
                                                '","value" : "' +
                                                format(new Date(dtFin), "MM/dd/yyyy") +
                                                '"}]','_blank')}>
                                                    {x.qtd}
                                                </Grid>
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })}


                    </Grid>
                </div>
            </div>
            {/* </Grid> */}
        </div>
    );
};
